import React from 'react';
import { createRoot } from 'react-dom/client';
import './sass/style.sass';
import { HomeHaka } from './HomeHaka';


createRoot(document.getElementById('root') ).render(<HomeHaka />)


